// extracted by mini-css-extract-plugin
export var divider = "CourseSummary-module--divider--7001f";
export var holder = "CourseSummary-module--holder--6a5be";
export var item = "CourseSummary-module--item--45023";
export var linebreak = "CourseSummary-module--linebreak--ab95b";
export var listing = "CourseSummary-module--listing--e8738";
export var mediaHolder = "CourseSummary-module--mediaHolder--7f6a2";
export var subTitle = "CourseSummary-module--subTitle--9ae42";
export var text = "CourseSummary-module--text--7a692";
export var title = "CourseSummary-module--title--9e7ec";
export var wrapper = "CourseSummary-module--wrapper--b456e";